import {
  GetCompanyCouriers,
  GetDesignations,
  GetProductTypes,
  GetTeamsDDL,
} from "../../api's/lookup";
import { GetLocations, GetProducts, GetSensors } from "../../api's/onboarding";
import {
  GetSettingsCouriers,
  GetSettingsLocations,
  GetTeams,
} from "../../api's/settings";
import { GetSettingsNewCouriers } from "../../api's/settings";

export const getProductsTypeDDL = (token) => {
  return GetProductTypes(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let res = data.data.data.length > 0 ? data.data.data : [];
          if (res.length > 0) {
            return res;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {
      return [];
    });
};

export const getDesignationDDL = (token) => {
  return GetDesignations(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getSensorsDDL = (token) => {
  return GetSensors(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getCouriersDDL = (token) => {
  return GetSettingsCouriers(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getCompanyCouriersDDL = (token) => {
  return GetCompanyCouriers(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp =
            data?.data?.data?.couriers?.length > 0
              ? data?.data?.data?.couriers
              : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getSettingsCouriersDDL = (token) => {
  return GetSettingsNewCouriers(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp =
            data?.data?.data?.couriers?.length > 0
              ? data?.data?.data?.couriers
              : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getProductDDL = (token) => {
  return GetProducts(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getLocationDDL = (token) => {
  return GetSettingsLocations(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp =
            data?.data?.data?.data?.length > 0 ? data?.data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getTeamsDDL = (token) => {
  return GetTeams(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {});
};

export const getTeamsDDLOFFeature = (token, fatureName) => {
  return GetTeamsDDL(token, fatureName)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          let res = data.data.data.length > 0 ? data.data.data : [];
          if (res.length > 0) {
            let arr = res;
            if (
              fatureName &&
              (fatureName === "Locations" ||
                fatureName === "Products" ||
                fatureName === "Shipment" ||
                fatureName === "Notifications" ||
                fatureName === "Alert Thresholds")
            ) {
              arr = res.filter((x) => x.name.toLowerCase() !== "default");
            }
            return arr;
          }
        } else {
          return [];
        }
      }
    })
    .catch((error) => {
      return [];
    });
};
